module.exports = __webpack_public_path__ + "static/media/ecosystem-layer.79b5aa10.png";